import axios_base from '@/api/axios_base'
import { store } from '@/store/store'
import { checkApiVersion, responseError } from 'Helpers/helpers'
import qs from 'qs'

export default {
  async makecall (method, params = {}, noErrorCheck = false, customEndpoint = '') {
    if (method !== 'reauth') {
      if (store?.getters?.sid) { params.sid = store.getters.sid }
    }

    params.r_x = Math.round(Math.random() * 10000)
    params.r_y = Math.round(Math.random() * 10000)
    params.r_z = (params.r_x * params.r_y) - 1621

    const baseURL = process.env.NODE_ENV !== 'production'
      ? customEndpoint || store.getters.amapiEndpoint : store.getters.amapiEndpoint

    let response
    try {
      response = await axios_base({
        method: 'post',
        baseURL,
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: method,
        data: qs.stringify(params)
      })
    } catch (err) {
      console.warn('amapi network error', err)
      throw err
    }
    if (response.status === 201) {
      if (noErrorCheck) {
        return response.data
      }
      if (response.data?.http_response_code === 401) {
        // handle session expired responses and clear sid
        let message
        try {
          await store.dispatch('attemptLogout')
          await store.dispatch('reportLogout', 'You were automatically logged out due to inactivity. Please re-login.')
        } catch (err) {
          console.warn('amapi attemptLogout error', err)
          message = err.message
        }
        // router.push({ name: 'login' }) // authrecheck is already doing this redirection
        if (!message) {
          message = response.data?.resultmsg || 'Session expired! Please, login to continue.'
        }
        throw new Error(message)
      }
      if (!responseError(response.data)) {
        // Set api version to store
        checkApiVersion(response.data.apiVersion)
        return response.data
      } else {
        throw responseError(response.data)
      }
    }
  },
  async cpanel_uapi (params) {
    // `params` is forwarded whole, `id` and `_username` included: core reads both
    // from the top level and appends the rest to the cPanel UAPI query string, so
    // they do reach cPanel as unknown query parameters — which it ignores. Every
    // consumer in the app has worked this way for years, and `cpanel_api2` below
    // still does. Stripping them would silently swallow an `id` that some UAPI
    // function takes as its own parameter, which is the more expensive mistake.
    const data = {
      id: params.id || store.getters.hosting.id,
      params,
      username: params._username
    }
    try {
      const response = await this.makecall('cpanel_uapi', { ...data })
      return response.payload
    } catch (e) {
      console.warn(e)
      throw e
    }
  },
  async cpanel_api2 (params) {
    try {
      const data = {
        id: store.getters.hosting.id,
        username: params._username,
        params
      }
      const response = await this.makecall('cpanel_api2', { ...data })
      return response.payload
    } catch (e) {
      throw new Error(e)
    }
  },
  /**
   * @param options {Object} - options
   * @param options.id {String} - service id
   * @param options.username {String} - cPanel username
   * @param options.module {String} - whm uapi module name
   * @param options.method {String} - whm uapi method
   */
  async whm_uapi (options) {
    const data = {
      ...options
    }
    const response = await this.makecall('whm_uapi', data)
    return response
  },
  /**
   * @param params Object { method: String, payload: Object }
   */
  async softaculous_api (params) {
    const data = {
      service: store.getters.hosting.id,
      username: params._username,
      ...{
        ...params,
        _username: undefined,
      },
      payload: JSON.stringify(params.payload)
    }
    try {
      const response = await this.makecall('softaculous', data)
      return response.softaculous
    } catch (e) {
      throw e
    }
  },

  async whmapi (params) {
    const id = params.id || store.getters.hosting.id
    const action = params.action
    const data = {
      id,
      action,
      params,
    }
    try {
      return await this.makecall('whmapi', data)
    } catch (e) {
      console.warn(e)
      throw e
    }
  },
}
